import { createAction } from 'utils/useReducerWithMiddleware'

import type { IProgressChange } from '../types'
import type { IUpdateState } from './types'
import { Action } from './types'

export const play = createAction(Action.PLAY)<null>()
export const pause = createAction(Action.PAUSE)<null>()
export const togglePlay = createAction(Action.TOGGLE_PLAY)<null>()
export const toggleFullScreen = createAction(Action.TOGGLE_FULLSCREEN)<null>()
export const setFullscreen = createAction(Action.SET_FULLSCREEN)<boolean>()
export const startSeeking = createAction(Action.START_SEEKING)<null>()
export const setPlaybackRate = createAction(Action.SET_PLAYBACK_RATE)<number>()
export const seekTo = createAction(Action.SEEK_TO)<number>()
export const setPlayed = createAction(Action.SET_PLAYED)<{
  playedSeconds: number
  duration: number
}>()
export const setVolume = createAction(Action.SET_VOLUME)<number>()
export const decreaseVolume = createAction(Action.DECREASE_VOLUME)<null>()
export const increaseVolume = createAction(Action.INCREASE_VOLUME)<null>()

export const muteToggle = createAction(Action.MUTE_TOGGLE)<null>()

export const showCc = createAction(Action.SHOW_CC)<null>()

export const setProgress = createAction(Action.SET_PROGRESS)<
  IProgressChange & { duration: number }
>()
export const update = createAction(Action.UPDATE)<IUpdateState>()
export const setDuration = createAction(Action.SET_DURATION)<number>()
